var map = {
	"./AppStore.png": 872,
	"./Excel.svg": 6335,
	"./GooglePlay.png": 1351,
	"./address.svg": 102,
	"./case.png": 3452,
	"./checkmark.png": 1257,
	"./css/_mixins.scss": 7348,
	"./css/_variables.scss": 1163,
	"./css/index.scss": 9135,
	"./css/roboto.css": 1074,
	"./excel.png": 7087,
	"./fonts/roboto/KFOkCnqEu92Fr1MmgVxEIzIFKw.woff2": 9797,
	"./fonts/roboto/KFOkCnqEu92Fr1MmgVxFIzIFKw.woff2": 710,
	"./fonts/roboto/KFOkCnqEu92Fr1MmgVxGIzIFKw.woff2": 6767,
	"./fonts/roboto/KFOkCnqEu92Fr1MmgVxHIzIFKw.woff2": 9144,
	"./fonts/roboto/KFOkCnqEu92Fr1MmgVxIIzI.woff2": 6439,
	"./fonts/roboto/KFOkCnqEu92Fr1MmgVxLIzIFKw.woff2": 1132,
	"./fonts/roboto/KFOkCnqEu92Fr1MmgVxMIzIFKw.woff2": 8301,
	"./fonts/roboto/KFOlCnqEu92Fr1MmEU9fABc4EsA.woff2": 4962,
	"./fonts/roboto/KFOlCnqEu92Fr1MmEU9fBBc4.woff2": 7432,
	"./fonts/roboto/KFOlCnqEu92Fr1MmEU9fBxc4EsA.woff2": 4399,
	"./fonts/roboto/KFOlCnqEu92Fr1MmEU9fCBc4EsA.woff2": 6432,
	"./fonts/roboto/KFOlCnqEu92Fr1MmEU9fCRc4EsA.woff2": 9536,
	"./fonts/roboto/KFOlCnqEu92Fr1MmEU9fChc4EsA.woff2": 590,
	"./fonts/roboto/KFOlCnqEu92Fr1MmEU9fCxc4EsA.woff2": 8398,
	"./fonts/roboto/KFOlCnqEu92Fr1MmSU5fABc4EsA.woff2": 4156,
	"./fonts/roboto/KFOlCnqEu92Fr1MmSU5fBBc4.woff2": 8006,
	"./fonts/roboto/KFOlCnqEu92Fr1MmSU5fBxc4EsA.woff2": 6465,
	"./fonts/roboto/KFOlCnqEu92Fr1MmSU5fCBc4EsA.woff2": 798,
	"./fonts/roboto/KFOlCnqEu92Fr1MmSU5fCRc4EsA.woff2": 1790,
	"./fonts/roboto/KFOlCnqEu92Fr1MmSU5fChc4EsA.woff2": 7424,
	"./fonts/roboto/KFOlCnqEu92Fr1MmSU5fCxc4EsA.woff2": 6032,
	"./fonts/roboto/KFOlCnqEu92Fr1MmWUlfABc4EsA.woff2": 5193,
	"./fonts/roboto/KFOlCnqEu92Fr1MmWUlfBBc4.woff2": 8861,
	"./fonts/roboto/KFOlCnqEu92Fr1MmWUlfBxc4EsA.woff2": 1768,
	"./fonts/roboto/KFOlCnqEu92Fr1MmWUlfCBc4EsA.woff2": 2035,
	"./fonts/roboto/KFOlCnqEu92Fr1MmWUlfCRc4EsA.woff2": 2851,
	"./fonts/roboto/KFOlCnqEu92Fr1MmWUlfChc4EsA.woff2": 5625,
	"./fonts/roboto/KFOlCnqEu92Fr1MmWUlfCxc4EsA.woff2": 3353,
	"./fonts/roboto/KFOlCnqEu92Fr1MmYUtfABc4EsA.woff2": 3571,
	"./fonts/roboto/KFOlCnqEu92Fr1MmYUtfBBc4.woff2": 2995,
	"./fonts/roboto/KFOlCnqEu92Fr1MmYUtfBxc4EsA.woff2": 8050,
	"./fonts/roboto/KFOlCnqEu92Fr1MmYUtfCBc4EsA.woff2": 809,
	"./fonts/roboto/KFOlCnqEu92Fr1MmYUtfCRc4EsA.woff2": 3145,
	"./fonts/roboto/KFOlCnqEu92Fr1MmYUtfChc4EsA.woff2": 6819,
	"./fonts/roboto/KFOlCnqEu92Fr1MmYUtfCxc4EsA.woff2": 2339,
	"./fonts/roboto/KFOmCnqEu92Fr1Mu4WxKOzY.woff2": 6477,
	"./fonts/roboto/KFOmCnqEu92Fr1Mu4mxK.woff2": 1093,
	"./fonts/roboto/KFOmCnqEu92Fr1Mu5mxKOzY.woff2": 570,
	"./fonts/roboto/KFOmCnqEu92Fr1Mu72xKOzY.woff2": 3817,
	"./fonts/roboto/KFOmCnqEu92Fr1Mu7GxKOzY.woff2": 7550,
	"./fonts/roboto/KFOmCnqEu92Fr1Mu7WxKOzY.woff2": 2974,
	"./fonts/roboto/KFOmCnqEu92Fr1Mu7mxKOzY.woff2": 388,
	"./kaspi_kz.png": 5374,
	"./logo.png": 3153,
	"./logo.svg": 3935,
	"./main_bg.png": 9197,
	"./mainblock0.png": 4142,
	"./mainblock1.png": 9927,
	"./mainblock2.png": 9244,
	"./mainblock3.png": 869,
	"./mainblock4.png": 8810,
	"./map_kk.png": 7239,
	"./map_ru.png": 9194,
	"./phone.svg": 8382,
	"./post_kz.png": 2164,
	"./statement.png": 6157,
	"./svg": 7473,
	"./svg.ts": 7473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;